<template>
  <div>
    <v-dialog v-model="open" max-width="600px" persistent>
      <v-card>
        <v-card-title>{{ getMonthLabel(month) }}の経過記録</v-card-title>

        <v-card-text>
          <v-textarea
            v-model="localContent"
            variant="outlined"
            rows="8"
            placeholder="経過記録を入力"
            hide-details
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn @click="close" color="grey" text>キャンセル</v-btn>
          <v-btn
            @click="save"
            color="primary"
            variant="flat"
            :loading="isSaving"
            :disabled="isSaving"
          >保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DialogMixin from '@/mixins/DialogMixin';

export default defineComponent({
  name: 'ProgressRecordEditDialog',

  mixins: [DialogMixin],

  props: {
    month: {
      type: Number,
      required: true,
    },
    content: {
      type: String,
      default: '',
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localContent: '',
    };
  },

  watch: {
    content: {
      immediate: true,
      handler(newVal: string) {
        this.localContent = newVal || '';
      },
    },
    isOpen(newVal: boolean) {
      if (newVal) {
        this.localContent = this.content || '';
      }
    },
  },

  methods: {
    getMonthLabel(month: number): string {
      const monthLabels: { [key: number]: string } = {
        4: '4月',
        5: '5月',
        6: '6月',
        7: '7月',
        8: '8月',
        9: '9月',
        10: '10月',
        11: '11月',
        12: '12月',
        1: '1月',
        2: '2月',
        3: '3月',
      };
      return monthLabels[month] || `${month}月`;
    },
    save() {
      this.$emit('save', this.localContent);
    },
  },
});
</script>
